import script from "./VCheckboxNew.vue?vue&type=script&setup=true&lang=js"
export * from "./VCheckboxNew.vue?vue&type=script&setup=true&lang=js"

import "./VCheckboxNew.vue?vue&type=style&index=0&id=345adbf0&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-345adbf0"]])

export default __exports__